import * as angular from 'angular';
import * as _ from 'lodash';

import { IValidationPageConfigurationService } from '../../services';
import { ValidationPageConfiguration } from '../../models';
import { Store } from '../Store';
import * as VALIDATIONPAGECONFIGURATIONS from './validationPageConfigurations.constants';

import {
    loadValidationPageConfigurations,
    loadValidationPageConfigurationsSuccess,
    updateValidationPageConfigurations,
    updateValidationPageConfigurationsSuccess,
} from './validationPageConfigurations.actions';
import { IWidget } from '../../widgets';


export interface IValidationPageConfigurationActionsService {
    getOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<ValidationPageConfiguration>;
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<ValidationPageConfiguration[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<ValidationPageConfiguration[]>;
    // addOne(target: ValidationPageConfiguration): (dispatch: any, getState: () => Store) => angular.IPromise<ValidationPageConfiguration[]>;
    // addMany(targets: ValidationPageConfiguration[]): (dispatch: any, getState: () => Store) => angular.IPromise<ValidationPageConfiguration[]>;
    updateReferenceGroup(groupType: string, referenceGroupGuid: string, widgets: IWidget[]): (dispatch: any, getState: () => Store) => angular.IPromise<ValidationPageConfiguration[]>;
    // updateOne(target: ValidationPageConfiguration): (dispatch: any, getState: () => Store) => angular.IPromise<ValidationPageConfiguration[]>;
    // updateMany(targets: ValidationPageConfiguration[]): (dispatch: any, getState: () => Store) => angular.IPromise<ValidationPageConfiguration[]>;
    // deleteOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<ValidationPageConfiguration[]>;
    // deleteMany(guids: string[]): (dispatch: any, getState: () => Store) => angular.IPromise<ValidationPageConfiguration[]>;
}

export class ValidationPageConfigurationsActionsService implements IValidationPageConfigurationActionsService {


    static serviceId = 'validationPageConfigurationActionsService';
    static $inject = ['$q', 'validationPageConfigurationService'];


    constructor(
        private _$q: angular.IQService,
        private _validationPageConfigurationService: IValidationPageConfigurationService) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { validationPageConfigurations } = getState();
            if (!validationPageConfigurations.isLoading && !validationPageConfigurations.isLoaded) {
                dispatch(loadValidationPageConfigurations());
                return this._validationPageConfigurationService
                    .getAll(true)
                    .then(data => {
                        let result = data.filter(c => c.guid === guid);
                        result = result.map(d => {
                            d.validationWidgets = this._validationPageConfigurationService.deserializeWidgets(d.validationWidgets);
                            return d;
                        });
                        dispatch(loadValidationPageConfigurationsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<ValidationPageConfiguration>(validationPageConfigurations.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { validationPageConfigurations } = getState();
            if (force || (!validationPageConfigurations.isLoading && !validationPageConfigurations.isLoaded)) {
                dispatch(loadValidationPageConfigurations());
                return this._validationPageConfigurationService
                    .getAll(force)
                    .then(data => {
                        data = data.map(d => {
                            d.validationWidgets = this._validationPageConfigurationService.deserializeWidgets(d.validationWidgets);
                            return d;
                        });
                        dispatch(loadValidationPageConfigurationsSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<ValidationPageConfiguration>(validationPageConfigurations.dictionary));
            }
        };
    }

    // addOne(target: ValidationPageConfiguration) {
    //     return this.addMany([target]);
    // }

    // addMany(targets: ValidationPageConfiguration[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { validationPageConfigurations } = getState();
    //         if (targets && targets.length > 0) {
    //             dispatch(addValidationPageConfigurations(targets));
    //             return this._ValidationPageConfigurationService.addValidationPageConfigurations(targets)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(addValidationPageConfigurationsSuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_ADD_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<ValidationPageConfiguration>(validationPageConfigurations.dictionary));
    //         }
    //     };
    // }
    updateReferenceGroup(groupType: string, referenceGroupGuid: string, widgets: IWidget[]) {
        return (dispatch: any, getState: () => Store) => {
            const { validationPageConfigurations } = getState();
            const list = _.values<ValidationPageConfiguration>(validationPageConfigurations.dictionary);
            const target = _.find(list, vpc => vpc.name === groupType);
            //         if (targets && targets.length > 0) {
            dispatch(updateValidationPageConfigurations([target]));
            return this._validationPageConfigurationService
                .updateReferenceGroup(groupType, referenceGroupGuid, widgets)
                .then(data => {
                    let result = data.filter(d => d.name === groupType);
                    result = result.map(d => {
                        d.validationWidgets = this._validationPageConfigurationService.deserializeWidgets(d.validationWidgets);
                        return d;
                    });
                    dispatch(updateValidationPageConfigurationsSuccess(result));
                    return result;
                })
                .catch((reason) => {
                    dispatch({ type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_UPDATE_ERROR, payload: reason });
                    return reason;
                });
            //         } else {
            // return this._$q.when(_.values<ValidationPageConfiguration>(validationPageConfigurations.dictionary));
            //         }
        };
    }
    // updateOne(target: ValidationPageConfiguration) {
    //     return this.updateMany([target]);
    // }

    // updateMany(targets: ValidationPageConfiguration[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { validationPageConfigurations } = getState();
    //         if (targets && targets.length > 0) {
    //             dispatch(updateValidationPageConfigurations(targets));
    //             return this._ValidationPageConfigurationService.updateValidationPageConfigurations(targets)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(updateValidationPageConfigurationsSuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_UPDATE_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<ValidationPageConfiguration>(validationPageConfigurations.dictionary));
    //         }
    //     };
    // }

    // deleteOne(guid: string) {
    //     return this.deleteMany([guid]);
    // }

    // deleteMany(guids: string[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { validationPageConfigurations } = getState();
    //         if (guids && guids.length > 0) {
    //             dispatch(deleteValidationPageConfigurations(guids));
    //             return this._ValidationPageConfigurationService.deleteValidationPageConfigurations(guids)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(deleteValidationPageConfigurationsSuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_DELETE_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<ValidationPageConfiguration>(validationPageConfigurations.dictionary));
    //         }
    //     };
    // }
}